export const errorRes = {
  description: {
    is: 'Lýsing',
    en: 'Description',
    pl: 'Opis',
  },
  traceparent: {
    is: 'Rakningarnúmer',
    en: 'Traceparent',
    pl: 'Identyfikator śledzenia',
  },
} as const;
